import React from 'react';
interface IconProps {
    width?: number;
    height?: number;
}

const CheckIcon = (props: IconProps) => {
    return (
        <svg viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M15.633.347a1.108 1.108 0 00-1.617 0l-8.48 8.758L1.971 5.42a1.16 1.16 0 00-.829-.337 1.134 1.134 0 00-.816.366A1.205 1.205 0 000 6.303a1.231 1.231 0 00.355.842l4.372 4.508a1.136 1.136 0 00.808.347 1.109 1.109 0 00.809-.347l9.29-9.58a1.207 1.207 0 000-1.726z"
                fill="#0F916C"
            />
        </svg>
    );
};

export default CheckIcon;
